
import { appConfig } from './app/app.config';
import { environment, setRuntimeConfig } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { register } from 'swiper/element/bundle';
register();

console.log('🔥 [main.ts] INICIO DEL ARCHIVO - Este mensaje debe aparecer SIEMPRE');

// Función para cargar configuración runtime ANTES de iniciar Angular
async function loadRuntimeConfig() {
  console.log('🚀 [main.ts] Intentando cargar runtime-config.json...');

  try {
    const response = await fetch('/assets/config/runtime-config.json');
    console.log('📡 [main.ts] Response status:', response.status);

    if (response.ok) {
      const config = await response.json();
      console.log('✅ [main.ts] Runtime config cargada:', config.CLIENTE, 'LOGO:', config.LOGO);
      setRuntimeConfig(config);
      return;
    } else {
      console.warn('⚠️ [main.ts] Response no OK:', response.status);
    }
  } catch (error) {
    console.error('❌ [main.ts] Error cargando runtime-config:', error);
  }

  console.log('📦 [main.ts] Usando configuración por defecto');
}

console.log('🎬 [main.ts] Antes de iniciar async');

// Iniciar aplicación
(async () => {
  console.log('🎯 [main.ts] DENTRO del async - inicio');

  // PRIMERO: Cargar configuración runtime
  await loadRuntimeConfig();

  console.log('⚙️ [main.ts] Config cargada, configurando Angular...');

  // SEGUNDO: Configurar Angular
  if (environment.production) {
    enableProdMode();
    console.log('🏭 [main.ts] Modo producción activado');
    // Desactivar console.log en producción - TEMPORALMENTE COMENTADO PARA DEBUG
    // window.console.log = function () { };
  }

  console.log('🚀 [main.ts] Bootstrapeando Angular...');

  // TERCERO: Bootstrap de Angular con la configuración ya cargada
  bootstrapApplication(AppComponent, appConfig).catch(err => console.error('💥 [main.ts] Error:', err));
})();

